import axios from "axios";
import {IResults} from "@/interfaces/IResults";
import UtilityString from "@/utilities/strings";
import API_CONFIG from "@/config/API_CONFIG";
import Router from "@/router";
import AuthService from "@/auth/authService";
import DEFAULT_LIST_INFO from "@/config/DEFAULT_LIST_INFO";
import { baseSaturnApiUrl } from './_endpoint';

let config = new API_CONFIG();
let apiUrl = baseSaturnApiUrl;
let apiKey = config.API_KEY;
let apiHeaderObj;
let apiv4Url = baseSaturnApiUrl;
let apiv5Url = baseSaturnApiUrl;


class SearchService {
  config = new API_CONFIG();
  auth = AuthService.getInstance();
  utility = new UtilityString();

  constructor() {
    axios.defaults.baseURL = apiUrl;

    apiHeaderObj = {
      headers: {
        "x-functions-key": apiKey,
      },
    };
  }

  async getResults(api, filter) {

    if (filter.actionId === undefined || filter.actionId === null) {
      return;
    }


    let results;

    //Convert object to query string
    let param = this.getFilter(filter);

    let correlationId = "&correlationId=" + this.utility.generateGUID();

    let paramString = this.utility.parseQueryString(param);

    // Dynamically switch base URL based on actionId and only for exact "global/list" path
    const useNewApiEndpoint = [6, 19, 24, 27, 10].includes(Number(param.actionId)) && 
      api === "global/list";
    
    
    const useNewInfoEndpoint = api === "global/list/info" || "global/details/info" === api;

       
    // Set appropriate base URL
    if (useNewApiEndpoint) {
      axios.defaults.baseURL = apiv4Url;
    }
    else if (useNewInfoEndpoint) {
      axios.defaults.baseURL =apiv5Url;
    }
    else {
      axios.defaults.baseURL = apiUrl;
    }

    try {
      results = await axios.get(api + "?" + paramString + correlationId, apiHeaderObj);
      return results.data;
    } catch (error) {
      // Check if this is a global/list/info API call
      if (api === "global/list/info") {
        //console.warn(`Failed to fetch global/list/info data, using fallback data. Error: ${error.message}`);
        
        // Return default structure with empty values for global/list/info
        return DEFAULT_LIST_INFO;
      }
      
      // For other APIs, rethrow the error
      throw error;
    }
  }

  getFilter(filterObj) {
    if (filterObj) {
      if (!filterObj.id) {
        filterObj.id = 0;
        filterObj.maximumRows = 100;
      }
    } else {
      filterObj = {
        id: 0,
        maximumRows: 100,
      };
    }

    let auth = AuthService.getInstance();
    return Object.assign(filterObj, auth.getAuthObject());
  }
}

export default SearchService;
